module.exports = __webpack_public_path__ + "static/media/you-voted.ee1f640a.png";